import * as React from 'react';
import { Department } from '../../models';

import Select from 'react-select';

import FindDealerStore from '../../stores/FindDealerStore';
import { observer, inject } from 'mobx-react';

interface Props {
  findDealerStore?: FindDealerStore;
}
interface State {
  selectedOption: object;
}

class FilterDepartmentsDropDown extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: { value: 'all', label: 'All departments' }
    };
  }
  componentDidMount() {
    const { findDealerStore } = this.props;
    findDealerStore.fetchDepartments();
  }
  handleChange = selectedOption => {
    const { findDealerStore } = this.props;
    this.setState({ selectedOption });
    findDealerStore.setDepartmentsFilter(selectedOption.value);
  };
  render() {
    const { departments, departmentsFilter } = this.props.findDealerStore;
    const renderSelect = () => {
      let options = [{ value: 'all', label: 'All departments' }];
      departments.map(department => {
        options.push({ value: department.name, label: department.name });
      });
      return (
        <Select
          name="form-field-name"
          clearable={false}
          value={departmentsFilter}
          onChange={this.handleChange}
          options={options}
        />
      );
    };
    return (
      <div className="filter-departments-dropdown">
        <div>
          <span className="filter-departments-dropdown__label">
            Departments:
          </span>{' '}
          {!!departments && renderSelect()}
        </div>
      </div>
    );
  }
}

export default inject('findDealerStore')(observer(FilterDepartmentsDropDown));
